import { PartnerConfigPartBaseResponse } from '../getPartnerConfig/getPartnerConfig.types'

export enum PartnerVolunteeringConfigKeys {
  VolunteeringAllowance = 'volunteering_allowance',
  VolunteeringActivityWorkingHoursCheck = 'volunteering_activity_working_hours_check',
  VolunteeringPostEventSurveys = 'volunteering_post_event_surveys',
  VolunteeringWaivers = 'volunteering_waivers',
  VolunteeringWaitlist = 'volunteering_waitlist',
  OpportunityDisclosure = 'volunteering_opportunity_disclosure'
}

export enum VolunteeringAllowancePeriodicity {
  Annual = 'annual',
  Quarterly = 'quarterly'
}

export type PartnerVolunteeringAllowanceConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.VolunteeringAllowance
  value: {
    periodicity: VolunteeringAllowancePeriodicity
    renewsAt: string
    allowanceMinutes: number
  }
}
export type PartnerActivityWorkingHoursCheckConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.VolunteeringActivityWorkingHoursCheck
  value: boolean
}

export type PartnerPostEventSurveysConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.VolunteeringPostEventSurveys
  value: {
    enabled: 'on' | 'off'
  }
}

export type PartnerVolunteeringWaiversConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.VolunteeringWaivers
  value: {
    enabled: 'on' | 'off'
  }
}

export type PartnerVolunteeringWaitlistConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.VolunteeringWaitlist
  value: boolean
}

export type PartnerOpportunityDisclosureConfig = PartnerConfigPartBaseResponse & {
  key: PartnerVolunteeringConfigKeys.OpportunityDisclosure
  value: {
    text: string
  }
}

export type GetPartnerVolunteeringConfigResponse = {
  data: {
    [PartnerVolunteeringConfigKeys.VolunteeringAllowance]?: PartnerVolunteeringAllowanceConfig
    [PartnerVolunteeringConfigKeys.VolunteeringActivityWorkingHoursCheck]?: PartnerActivityWorkingHoursCheckConfig
    [PartnerVolunteeringConfigKeys.VolunteeringPostEventSurveys]?: PartnerPostEventSurveysConfig
    [PartnerVolunteeringConfigKeys.VolunteeringWaivers]?: PartnerVolunteeringWaiversConfig
    [PartnerVolunteeringConfigKeys.VolunteeringWaitlist]?: PartnerVolunteeringWaitlistConfig
    [PartnerVolunteeringConfigKeys.OpportunityDisclosure]?: PartnerOpportunityDisclosureConfig
  }
  object: string
}
